<template>
	<el-dialog @opened="resetDoms" @closed="freshList" title="手动添加样品" append-to-body :visible.sync="visible"
		:close-on-click-modal="false" width="60%">
		<el-steps :active="active" align-center finish-status="success" style="margin-top: 20px; margin-bottom: 60px">
			<el-step title="样品信息"></el-step>
			<el-step title="添加检项"></el-step>
		</el-steps>
		<div class="step_content">
			<form-template v-show="!active" ref="formData" :mod="mod" :orderId="orderId"></form-template>
			<div v-show="active">
				<p class="btn">
					<el-button type="primary" @click="openAdd">添加</el-button>
				</p>
				<el-table :data="tableData" v-loading="dataListLoading" max-height="360" style="width: 100%">
					<el-table-column v-show="v.showed" v-for="(v, i) in tableHeader" :key="i" :prop="v.field"
						:label="v.label">
						<template slot-scope="{ row }">
							<span :style="{color:v.options.color}">
								{{ row[v.field] }}
							</span>
						</template>
					</el-table-column>
					<el-table-column header-align="center" align="center" width="100" label="操作" fixed="right">
						<template slot-scope="scope">
							<el-button style="padding: 0;" type="text" @click="delOne(scope.$index)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div>
		</div>
		<div slot="footer">
			<!-- <p v-if="active == 1" style="margin-bottom: 16px;font-size: 18px;color: #FF6F77;font-weight: bold;text-align: center;">合计：{{totalPrice}}</p> -->
			<el-button @click="active--" v-if="active == 1">上一步</el-button>
			<el-button type="primary" @click="next" v-if="!active">下一步</el-button>
			<el-button type="primary" @click="addSample" v-if="active == 1">确 定</el-button>
		</div>
		<!-- 手动添加样品--添加检项 -->
		<add-item v-if="additemVisible" ref="additemVisible" @addPrj="getPrjTable"></add-item>
	</el-dialog>
</template>

<script>
	import AddItem from "./addItem.vue";
	import { downloadFile } from "@/utils";
	import formTemplate from "@/components/formTemplate.vue"
	export default {
		components: {
			AddItem,
			formTemplate
		},
		data() {
			return {
				tableData: [],
				tableHeader: [],
				mod: {
					formData:{
						list:[]
					}
				},
				active: 0,
				additemVisible: false,
				visible: false,
				orderId: '',
				dataListLoading: false,
				sampleId: '',
				cellArr: [],
				cellPos:0,
				cellArr1: [],
				cellPos1:0,
				totalPrice:0.00
			};
		},
		computed: {
			upAddr() {
				return window.SITE_CONFIG.baseUrl + '/checkmall-file/api/file/upload';
			}
		},
		methods: {
			freshPrice(){
				// this.totalPrice = 0.00;
				// this.tableData.forEach(v=>{
				// 	this.totalPrice += Number(v.costVal);
				// });
				// this.totalPrice = this.totalPrice.toFixed(2);
			},
			getPrjTable(arr){
				this.totalPrice = 0.00;
				arr.forEach(v=>{
					v.costVal = v.projectPrice;
				})
				this.tableData = this.tableData.concat(arr);
				this.freshPrice();
				this.$refs.additemVisible.dialogVisible = false;
			},
			downloadFile(url, fileName) {
				downloadFile(url, fileName);
			},
			next() {
				this.$refs.formData.$refs.formRef.validate((valid) => {
					if (valid) {
						// 找到下拉选中的样本prn
						this.mod.formData.list.forEach(item =>{
							if(item.field == 'goods_name'){
								item.options.valueData.forEach(v=>{
									if(v[item.options.field]==item.val){
										this.sampleId = v.prn;
									}
								})
							}
						})
						this.active++;	
					}
				});
			},
			openAdd() {
				this.additemVisible = true;
				this.$nextTick(() => {
					this.$refs.additemVisible.init(this.orderId, 1, this.tableData.map(v => {
						return v.projectId
					}),{
						goodsPrn:this.sampleId
					});
				})
			},
			delOne(idx) {
				this.$confirm(`确定进行["删除"]操作?`, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					this.tableData.splice(idx, 1);
					this.$message({
						message: "删除成功",
						type: "success"
					});
					this.freshPrice();
				});
			},
			uploadSuccess(response, item) {
				this.formData[item.field.split('.').length>1 ? item.field.split('.')[1] : item.field] = [response.data.storage];
				this.$forceUpdate();
				this.setForm(item);
			},
			getConfig(type) {
				let params = {
					orderId: this.orderId,
					moduleKey: type
				}
				this.$http.post(this.$api.orderApi.getConfig, params).then(({
					data
				}) => {
					this.visible = true;
					let list = data.data.list.filter(v => v.showed == true) || [];
					if (type === 'YPXQ_YP') {
						// 样品表单
						this.$nextTick(() => {
							this.active = 0;
							this.mod = {
								formData:{
									list:list
								}
							}
							list.forEach(item=>{
								this.$set(item,'val',['file','checkbox'].includes(item.type) ? [] : '');
								this.$set(this.mod.formData,item.field,['file','checkbox'].includes(item.type) ? [] : '');
							})
							this.$refs.formData.$refs.formRef.resetFields();
						})
					} else {
						this.tableData = [];
						this.tableHeader = list;
					}
				});
			},
			init(orderId) {
				this.orderId = orderId;
				this.sampleId = '';//清空样品id
				this.totalPrice = 0.00;//清空检项合计
				// 获取样品表单项、检项列表配置
				this.getConfig("YPXQ_YP");
				this.getConfig("YPXQ_JX");
			},
			addSample(){
				this.$http.post(this.$api.orderApi.addSampleByHand, {
					orderId: Number(this.orderId),
					projectIds:this.tableData.map(v=>{return String(v.projectId)}),
					objId:this.sampleId,
					...this.$refs.formData.getFormData()
				}).then(({data}) => {
					if (data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.visible=false;
					}
				});
			},
			freshList() {
				this.$emit('refreshDataList');
			},
			resetDoms() {
				this.formData = {};
				this.$refs.formData.$refs.formRef.resetFields();
				this.active = 0;
				this.tableData = [];
			}
		}
	}
</script>

<style lang="scss" scoped>
	.btn {
		text-align: right;
		margin-bottom: 8px;

		.el-button {
			width: 64px;
			padding: 0;
			line-height: 26px;
			border-radius: 14px;
			font-weight: bold;
			font-size: 12px;
		}
	}

	::v-deep .el-dialog__header {
		line-height: 56px;
	}

	.el-dialog__footer .el-button {
		border-radius: 20px;
		width: 80px;
		line-height: 38px;
		font-size: 14px;
	}
</style>
